module.exports = __webpack_public_path__ + "static/media/aboutUs1.7788e0f1.jpg";